/* Billing dashboard interactions: cancel modal, reason toggle, loading state */

(function initBilling() {
  var trigger = document.querySelector("[data-billing-cancel-trigger]");
  var modal = document.querySelector("[data-billing-cancel-modal]");
  if (!trigger || !modal) return;

  var dismiss = modal.querySelector("[data-billing-cancel-dismiss]");
  var reasonSelect = modal.querySelector("[data-billing-reason-select]");
  var reasonText = modal.querySelector("[data-billing-reason-text]");
  var form = modal.querySelector("form");

  // Open
  trigger.addEventListener("click", function () {
    modal.showModal();
  });

  // Close via button
  if (dismiss) {
    dismiss.addEventListener("click", function () {
      modal.close();
    });
  }

  // Close on backdrop click
  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.close();
    }
  });

  // Toggle free-text field when "other" is selected
  if (reasonSelect && reasonText) {
    reasonSelect.addEventListener("change", function () {
      var show = reasonSelect.value === "other";
      reasonText.hidden = !show;
      if (show) reasonText.focus();
    });
  }

  // Loading state on submit
  if (form) {
    form.addEventListener("submit", function () {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.classList.add("is-loading");
        btn.disabled = true;
      }
    });
  }
})();
